import yup from 'src/libraries/validator.library';
import {
  PolygonListSchema,
  PolygonFormSchema,
  IPolygonForm,
} from 'src/models/polygon.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('polygon', { limit: 0 }, PolygonListSchema);
  },
  updatePUT: async (id: number, data: IPolygonForm) => {
    return http.put(`polygon/${id}`, data, PolygonFormSchema);
  },
  addPOST: async (data: IPolygonForm) => {
    return http.post('polygon', data, PolygonFormSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`polygon/${id}`, yup.mixed());
  }
};

export default services;
